import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";

const MOVES = [
  { key: "rock", emoji: "✊", label: "Rock", beats: "scissors" },
  { key: "paper", emoji: "✋", label: "Paper", beats: "rock" },
  { key: "scissors", emoji: "✌️", label: "Scissors", beats: "paper" },
];
const WIN = 5;

export function RockPaperScissors() {
  const [scores, setScores] = useState({ you: 0, cpu: 0 });
  const [pick, setPick] = useState(null);
  const [cpuPick, setCpuPick] = useState(null);
  const [msg, setMsg] = useState("Pick your move!");
  const [matchOver, setMatchOver] = useState(false);

  const play = (move) => {
    if (matchOver) return;
    const cpu = MOVES[Math.floor(Math.random() * 3)];
    setPick(move); setCpuPick(cpu);
    let result, ns = { ...scores };
    if (move.key === cpu.key) result = "Draw!";
    else if (move.beats === cpu.key) { result = "You win the round! 🎉"; ns.you += 1; }
    else { result = "CPU wins the round!"; ns.cpu += 1; }
    setScores(ns);
    if (ns.you >= WIN) { setMsg("🏆 You won the match!"); setMatchOver(true); }
    else if (ns.cpu >= WIN) { setMsg("💀 CPU won the match!"); setMatchOver(true); }
    else setMsg(result);
  };

  const reset = () => { setScores({ you: 0, cpu: 0 }); setPick(null); setCpuPick(null); setMsg("Pick your move!"); setMatchOver(false); };

  return (
    <div className="flex flex-col items-center w-full max-w-md" data-testid="rps-game">
      <div className="flex items-center justify-around w-full mb-6">
        <div className="text-center"><p className="text-xs uppercase text-neon-cyan font-bold">You</p><p className="font-display font-black text-4xl text-neon-cyan">{scores.you}</p></div>
        <span className="text-zinc-600 font-mono text-sm">first to {WIN}</span>
        <div className="text-center"><p className="text-xs uppercase text-neon-pink font-bold">CPU</p><p className="font-display font-black text-4xl text-neon-pink">{scores.cpu}</p></div>
      </div>

      <div className="flex items-center justify-center gap-6 h-24 mb-4">
        <div className="text-6xl" data-testid="rps-you">{pick ? pick.emoji : "❔"}</div>
        <span className="font-display font-black text-zinc-600">VS</span>
        <div className="text-6xl" data-testid="rps-cpu">{cpuPick ? cpuPick.emoji : "❔"}</div>
      </div>

      <p className="font-display font-bold text-lg mb-6 text-center min-h-[28px]" data-testid="rps-msg">{msg}</p>

      {!matchOver ? (
        <div className="grid grid-cols-3 gap-3 w-full">
          {MOVES.map((m) => (
            <button key={m.key} onClick={() => play(m)} data-testid={`rps-${m.key}`}
              className="py-5 rounded-xl bg-zinc-900 border-2 border-zinc-700 hover:border-neon-cyan transition-colors flex flex-col items-center gap-1">
              <span className="text-3xl">{m.emoji}</span>
              <span className="text-xs uppercase font-bold text-zinc-400">{m.label}</span>
            </button>
          ))}
        </div>
      ) : (
        <Button onClick={reset} data-testid="rps-reset" className="bg-neon-cyan text-black rounded-none font-bold uppercase tracking-widest">
          <RotateCcw className="w-4 h-4 mr-1" /> Play Again
        </Button>
      )}
    </div>
  );
}
